/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `gross_ticket_sales` - gross_ticket_sales
 * * `net_ticket_sales` - net_ticket_sales
 * @export
 */
export const SettlementBasisEnum = {
    GrossTicketSales: 'gross_ticket_sales',
    NetTicketSales: 'net_ticket_sales'
} as const;
export type SettlementBasisEnum = typeof SettlementBasisEnum[keyof typeof SettlementBasisEnum];


export function instanceOfSettlementBasisEnum(value: any): boolean {
    for (const key in SettlementBasisEnum) {
        if (Object.prototype.hasOwnProperty.call(SettlementBasisEnum, key)) {
            if (SettlementBasisEnum[key as keyof typeof SettlementBasisEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SettlementBasisEnumFromJSON(json: any): SettlementBasisEnum {
    return SettlementBasisEnumFromJSONTyped(json, false);
}

export function SettlementBasisEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettlementBasisEnum {
    return json as SettlementBasisEnum;
}

export function SettlementBasisEnumToJSON(value?: SettlementBasisEnum | null): any {
    return value as any;
}

export function SettlementBasisEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SettlementBasisEnum {
    return value as SettlementBasisEnum;
}
